function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "11",
  height: "20",
  viewBox: "0 0 11 20",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M.025 9.992c-.053.385.067.79.362 1.088l8.46 8.531a1.274 1.274 0 001.806-.002l-.041.042c.499-.503.501-1.317.001-1.82L2.85 10l7.764-7.83A1.3 1.3 0 0010.612.35l.04.042A1.268 1.268 0 008.848.39L.387 8.92a1.29 1.29 0 00-.362 1.07z",
  fill: "currentColor",
  fillRule: "evenodd"
})));